import { getQueryParams } from '../request'

export const getCurrentProviderFromQueryParams = (): string => getQueryParams().currentProvider as string
